import { useState, useEffect } from 'react';

import AppDemo from './components/app-demo-site-card/app-demo.js';

function App() {

	useEffect(() => {
		let myEvent = new CustomEvent('wcfSubcompsService', {detail:{id:"site-card.botones", variant:1}});
		document.dispatchEvent(myEvent);
		myEvent = new CustomEvent('wcfSubcompsService', {detail:{id:"site-card.botones_1", variant:1}});
		document.dispatchEvent(myEvent);
		
		myEvent = new CustomEvent('wcfSubcompsService', {detail:{id:"site-card.botones_2", variant:1}});
		document.dispatchEvent(myEvent);
				
		myEvent = new CustomEvent('wcfSubcompsService', {detail:{id:"site-card.botones", button:"UX/UI"}});
		document.dispatchEvent(myEvent);
		myEvent = new CustomEvent('wcfSubcompsService', {detail:{id:"site-card.botones_1", button:"Design"}});
		document.dispatchEvent(myEvent);
		myEvent = new CustomEvent('wcfSubcompsService', {detail:{id:"site-card.botones_2", button:"CSS"}});
		document.dispatchEvent(myEvent);
		
	}, []);
	
	return (
		<AppDemo></AppDemo>	
	);
}

export default App;